import { CatalogState } from '@marketplace-web/catalog/catalog-data'

import {
  CatalogAction,
  isCatalogBrandAction,
  isDataAction,
  isDtoAction,
  isDynamicFilterAction,
  isFacetedCategoriesAction,
  isFilterAction,
  isGeneralAction,
  isItemsAction,
} from './actionTypes'
import { filterReducer } from './filterReducer'
import { dynamicFiltersReducer } from './dynamicFiltersReducer'
import { dtoReducer } from './dtoReducer'
import { dataReducer } from './dataReducer'
import { catalogBrandReducer } from './catalogBrandReducer'
import { generalReducer } from './generalReducer'
import { itemsReducer } from './itemsReducer'
import { facetedCategoriesReducer } from './facetedCategoriesReducer'

export const catalogReducer = (state: CatalogState, action: CatalogAction): CatalogState => {
  return {
    filters: isFilterAction(action) ? filterReducer(state.filters, action) : state.filters,
    dynamicFilters: isDynamicFilterAction(action)
      ? dynamicFiltersReducer(state.dynamicFilters, action)
      : state.dynamicFilters,
    dtos: isDtoAction(action) ? dtoReducer(state.dtos, action) : state.dtos,
    data: isDataAction(action) ? dataReducer(state.data, action) : state.data,
    catalogBrand: isCatalogBrandAction(action)
      ? catalogBrandReducer(state.catalogBrand, action)
      : state.catalogBrand,
    general: isGeneralAction(action) ? generalReducer(state.general, action) : state.general,
    items: isItemsAction(action) ? itemsReducer(state.items, action) : state.items,
    facetedCategories: isFacetedCategoriesAction(action)
      ? facetedCategoriesReducer(state.facetedCategories, action)
      : state.facetedCategories,
  }
}
